import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFormAction } from "../../Actions/FormAction/FormAction";
import { createSectionFormAction } from "../../Actions/Section&FieldAction/SectionFieldAction";

const SectionFieldsModal = ({ closeModal }) => {
  const [title, setTitle] = useState(null);
  const [formId, setFormId] = useState(null);
  const dispatch = useDispatch();
  const getForm = useSelector((state) => state.getForm);
  const { forms } = getForm;
  const [error, setError] = useState({});
  
  useEffect(() => {
    dispatch(getFormAction([1, 2]));
  }, []);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (title == "" || title == null) {
      setError({
        ...error,
        title: "تکایە خانەکە پڕکەرەوە",
      });
      return;
    } else if (formId == "" || formId == null || formId == -1) {
      setError({
        ...error,
        title: "تکایە خانەکە پڕکەرەوە",
      });
      return;
    } else {
      dispatch(createSectionFormAction(formId, title));
      closeModal()
      setError({})
    }
  };
  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-container">
          <div className="modal-header ">
            <h3 className="cursor-pointer" onClick={closeModal}>
              X
            </h3>
          </div>
          <form action="" onSubmit={handleSubmit}>
            <div className="flex flex-col gap-2">
              <div>
                <label htmlFor="Form">فۆرمەکە دیاری بکە </label>
              </div>
              <select
                name=""
                onChange={(e) => setFormId(e.target.value)}
                className="input mt-1"
                id="Form"
              >
                <option value="-1">تکایە فۆرمەکە هەڵبژێرە</option>
                {forms?.map((form, index) => {
                  return (
                    <option value={form.id} key={index}>
                      {form.name}
                    </option>
                  );
                })}
              </select>
              <div className="text-red-400">{error && error.title}</div>

              <div>
                <div>
                  <label htmlFor="title">ناونیشانی بۆ دابنێ</label>
                </div>
                <input
                  type="text"
                  onChange={(e) => setTitle(e.target.value)}
                  name=""
                  className="input mt-1"
                  placeholder="ناونیشان"
                />
                <div className="text-red-400">{error && error.title}</div>
              </div>
            </div>
            <div className="modal-footer gap-2">
              <button type="submit" className="btn-primary">
                Save
              </button>
              <button className="btn-danger" onClick={closeModal}>
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SectionFieldsModal;
